import { render, staticRenderFns } from "./nullBox.vue?vue&type=template&id=f724ddfe&scoped=true"
import script from "./nullBox.vue?vue&type=script&lang=js"
export * from "./nullBox.vue?vue&type=script&lang=js"
import style0 from "./nullBox.vue?vue&type=style&index=0&id=f724ddfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f724ddfe",
  null
  
)

export default component.exports